import React from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/pages/trade-mobile.scss';
import TabHeader from '@/components/TabHeader/TabHeader';
import OrderBookMobile from '../../components/OrderTable/OrderBook.mobile';
import OrderHistoryMobile from '../../components/OrderTable/OrderHistory.mobile';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import RightArrowIcon from '@/assets/images/icons/mobiles/currentaccount_icon@2x.png';
import PlaceOrderMobile from '../PlaceOrder/PlaceOrder.mobile';

const PLACE_ORDER = 2;
const ORDER_BOOK_TABLE = 3;
const ORDER_HISTORY_TABLE = 4;

class TradeMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeTabs:[
        {id:1,title:'menu_place_order'},
        {id:2,title:'order_book_title'},
        {id:3,title:'order_history_title'}
      ],
      orderTableTab: PLACE_ORDER,
    }
  }

  render() {
    const { language, currentTradingAccount } = this.props;
    const { tradeTabs , orderTableTab} = this.state;
    return (
      <React.Fragment>
        <div className='trading-mobile-container'>
        <section className="cash-account" onClick={() => mobileSubLayoutAction.openSwitchAccount()} >
            <label>
              {currentTradingAccount.tradingAccountID ? `${currentTradingAccount.accountType==='M' ? language.common_margin_account : language.common_cash_account}: ${currentTradingAccount.tradingAccountID}`
              : `${currentTradingAccount.accountType==='M' ? language.common_margin_account : language.common_cash_account}: ${currentTradingAccount.label}`
            }
            </label>
            <img src={RightArrowIcon} alt="right_arrow" />
          </section>
                <TabHeader
                  TabHeader tabs={tradeTabs}
                  onChange={this.handleChangeOrderTableTab}
                  // maximumDate={maximumDate}
                  // onChangeDatePicker={this.handleChangeDatePicker}
                  // onChangeMarket={this.handleChangeMarket}
                />
                {orderTableTab === PLACE_ORDER && <PlaceOrderMobile innerRef={e => this.trademobileRef = e }/>}
                {orderTableTab === ORDER_BOOK_TABLE && <OrderBookMobile innerRef={e => this.orderBookRef = e} />}
                {orderTableTab === ORDER_HISTORY_TABLE && <OrderHistoryMobile innerRef={e => this.orderHistoryRef = e} />}
        </div>
      </React.Fragment>
    )
  }

  handleChangeOrderTableTab = (tab) => {
    switch (tab.main.title) {
      case 'order_book_title': {
        this.setState({
          orderTableTab: ORDER_BOOK_TABLE,
          searchParams: {
            status: '',
            startDate: '',
            endDate: ''
          }
        })
        break;
      }
      case 'order_history_title': {
        // const maximumDate = this.getMaximumDate();
        this.setState({
          orderTableTab: ORDER_HISTORY_TABLE,
          // searchParams: {
          //   status: '',
          //   startDate: this.convertDateObjectToString(maximumDate),
          //   endDate: this.convertDateObjectToString(maximumDate)
          // }
        }, () => {
          // this.tabHeaderOrderRef.setDatePickerValue(maximumDate);
        })
        break;
      }
      case 'menu_place_order': {
        this.setState({
          orderTableTab: PLACE_ORDER,
        })
        break;
      }
      default: break;
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
  })
)(TradeMobile)
